export class ContactThanksPage {
  init(): void {
    // お問い合わせ完了ページ
  }
}
